export const notEmpty = (val, setErrorMesg, Msg) => {
  if (val) {
    if (val.length < 1) {
      setErrorMesg(Msg);
      return false;
    } else {
      return true;
    }
  } else {
    setErrorMesg(Msg);
  }
};

export const notNumber = (val, setErrorMesg, Msg) => {
  try {
    if (Number.isInteger(Number(val))) {
      return true;
    } else {
      setErrorMesg(Msg);
      return false;
    }
  } catch {
    setErrorMesg(Msg);
    return false;
  }
};

const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const nameRegex = /^[a-z]+$/i;
const passRegex = /[A-Za-z0-9#?!@$%^&*-]{8,}/;

export const testEmail = (s) => {
  return emailRegex.test(s);
};

export const testName = (s) => {
  return nameRegex.test(s);
};

export const testPass = (s) => {
  return passRegex.test(s);
};

class validator {
  testEmail = (s) => {
    return emailRegex.test(s);
  };
  testName = (s) => {
    return nameRegex.test(s);
  };
  testPass = (s) => {
    return passRegex.test(s);
  };
}

export default new validator();
